import axiosInstance from '../helpers/axiosInstance';

export const getOutwardLogsApi = async (item) => {
    const response = await axiosInstance.get(`staff/outwardLogs?${item}`);
    return response.data;
};

export const createCoProductApi = async (request) => {
    const response = await axiosInstance.post('staff/counterSale', request.formData);
    return response.data;
};

export const updateCoProductApi = async (request) => {
    const response = await axiosInstance.put('staff/counterSale', request.formData);
    return response.data;
};

export const deleteCoProductApi = async (id) => {
    const response = await axiosInstance.delete(`staff/counterSale/${id}`);
    return response.data;
};

export const getCoProductListApi = async (request) => {
    const response = await axiosInstance.post('staff/counterSaleDetails', request.formData);
    return response.data;
};

export const getCoProjectListApi = async (id) => {
    const response = await axiosInstance.get(`staff/counterSaleProjects/${id}`);
    return response.data;
};

export const getVendorProjectListApi = async (id) => {
    const response = await axiosInstance.get(`staff/outwardReturn/${id}/purchaseOrderProjectDetails`);
    return response.data;
};

export const updateCoOutwardtApi = async (request) => {
    const response = await axiosInstance.put('staff/outward/counterSale', request.formData);
    return response.data;
};

export const createVendorProductApi = async (request) => {
    const response = await axiosInstance.post('staff/outwardReturn', request.formData);
    return response.data;
};

export const updateVendorProductApi = async (request) => {
    const response = await axiosInstance.put('staff/outwardReturn/productAndQuantity', request.formData);
    return response.data;
};

export const deleteVendorProductApi = async (id) => {
    const response = await axiosInstance.delete(`staff/outwardReturn/${id}`);
    return response.data;
};

export const getVendorProductListApi = async (request) => {
    const response = await axiosInstance.post('staff/outwardReturnDetail', request.formData);
    return response.data;
};

export const updateReviewApi = async (request) => {
    const response = await axiosInstance.put('staff/outwardReturn/vendorAndReturnRemarks', request.formData);
    return response.data;
};

export const updateOutwardReturnProductApi = async (request) => {
    const response = await axiosInstance.post('staff/product/outwardReturn/v2', request.formData);
    return response.data;
};

export const getOutwardCsvApi = async (item) => {
    const response = await axiosInstance.get(`staff/outwardLogs/csv?${item}`, { responseType: 'text' });
    return response.data;
};
